import { render, staticRenderFns } from "./MeusAtendimentos.vue?vue&type=template&id=1b3832ca"
import script from "./MeusAtendimentos.vue?vue&type=script&lang=js"
export * from "./MeusAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports